import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface BosLocationInputProps {
  onBosLocationChange: (value: string) => void;
  bosLocationValue: string;
  isEnabled: boolean;
}

export const BosLocationInput: React.FC<BosLocationInputProps> = ({
  onBosLocationChange,
  bosLocationValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="BOS LOCATION"
      label="Enter BOS location details:"
      placeholder="Enter BOS location information..."
      value={bosLocationValue}
      onChange={onBosLocationChange}
      isEnabled={isEnabled}
      isTextArea
    />
  );
};
